import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/Sidebar";

const Dashboard = () => {
  const [open, setOpen] = useState(false);


  const toggleOpen = () => {
    document.body.classList.toggle("overflow-hidden");
    setOpen((current) => !current);
  };
  return (
    <div className="dashboard relative">
      <Sidebar open={open} toggleOpen={toggleOpen} />
      <Outlet context={[toggleOpen]} />
    </div>
  );
};

export default Dashboard;
